import { render, staticRenderFns } from "./AdminGames.vue?vue&type=template&id=7ac89518&scoped=true"
import script from "./AdminGames.vue?vue&type=script&lang=js"
export * from "./AdminGames.vue?vue&type=script&lang=js"
import style0 from "./AdminGames.vue?vue&type=style&index=0&id=7ac89518&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac89518",
  null
  
)

export default component.exports